export default __webpack_public_path__ + "static/16-bfbda97b10f659c8d712c41ea930b2d8.png";